import React from 'react';
import './pills.css';

const Pills = (props) => {
  return ( 
  <div className={props.pillstyle}>{props.pillinside}</div>  
);
}
 
export default Pills;